import { insertVideo, getAtomicEntityInfo } from "lib/helpers";
import { createToolbarButtons } from "../createToolbarButtons";
import { InsertVideoButton } from "./InsertVideoButton";
import { InsertVideoBar } from "./InsertVideoBar";
import { VideoBlock } from "./VideoBlock";
import { RichUtils } from "draft-js";


const defaultOptions = {
	buttons: ['video'],
}

const BUTTON_MAP = {
	video: InsertVideoButton,
}

/**
 * @returns {DraftEditorPlugin}
 */
export function createVideoPlugin(options = defaultOptions) {
	options = { ...defaultOptions, ...options };
	return {
		name: 'video',

		getToolbarButtons(props) {
			if (props.env !== 'root') {
				return null;
			}
			const editorState = props.store.getEditorState();
			// 代码块不支持视频
			if (RichUtils.getCurrentBlockType(editorState) === 'code-block') {
				return null;
			}
			return createToolbarButtons(BUTTON_MAP, options.buttons, props);
		},

		getToolbarWidgets({ store }) {
			return [{
				key: 'video-bar',
				component: InsertVideoBar,
				props: {
					onInsert({ videoPlatform, videoId }) {
						insertVideo(store, { videoId, videoPlatform });
					}
				}
			}];
		},

		getBlockRenderInfo(block, store) {
			const entityInfo = getAtomicEntityInfo(block, store);
			if (entityInfo && entityInfo.entityType === 'VIDEO') {
				return {
					component: VideoBlock,
					editable: false,
					props: {
						...entityInfo,
						store,
						videoWidth: options.videoWidth,
						videoHeight: options.videoHeight,
					}
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/videoPlugin/createVideoPlugin.js